import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"

import {
    GridCell,
    css,
    Theme,
    Spinner,
} from "@bdfx/mergado-ui-kit"

import Select from 'react-select'

import { FontFamilyOptionType, ImagickFontsType } from "app/reducers/imagickFontsReduxList";
import { find, uniqBy } from 'lodash'
import { FontsInProject } from 'app/reducers/fonts-in-project'
import { setFontsInProjectToStore } from 'actions'

export interface ImagickFont {
    image: string
    text_fontfamily: string
    file: string
    style: string
    family: string
    weight?: number
    stretch?: string
}

interface Props {
    currentFontFamily: string
    sampleText: string
    setFontFamily: Function
    imagickFonts: ImagickFontsType
    fontsInProject: FontsInProject
    setFontsInProjectToStore: typeof setFontsInProjectToStore
}

export interface FontOptionType {
    name: string
    value: string
    image: string
    style: string
    family: string
}

class ImagickFontSelect extends Component<Props> {
    constructor(props) {
        super(props)
    }

    componentDidMount(): void {
        const allFontsMap: FontOptionType[] = this.props.imagickFonts.data.fontsMap.map((o: ImagickFont) => ({
            name: o.text_fontfamily,
            value: o.text_fontfamily,
            image: o.image,
            style: o.style,
            family: o.family,
        }))

        const fontByName: FontOptionType = find(allFontsMap, (fontOption: FontOptionType) => {
            return fontOption.name === this.props.currentFontFamily
        })

        if (!fontByName) {
            this.props.setFontFamily('Roboto')
        }
    }

    customFilter = (option, phrase) => {
        return typeof option.data.value === "string" ? option.data.value.toLowerCase().includes(phrase.toLowerCase()) : true
    }

    highlightTextGetter = item => typeof item.name === "string" ? item.name : "-"

    render() {
        const { imagickFonts, fontsInProject } = this.props

        if (!imagickFonts || !imagickFonts.data || !imagickFonts.data.fontsMap) {
            console.debug('fonts not loaded')
            return <Spinner type={'bubbles'} />
        }

        const allFontsMap: FontOptionType[] = imagickFonts.data.fontsMap.map((o: ImagickFont) => ({
            name: o.text_fontfamily,
            value: o.text_fontfamily,
            image: o.image,
            style: o.style,
            family: o.family,
        }))

        const fontByName: FontOptionType = find(allFontsMap, (fontOption: FontOptionType) => {
            return fontOption.name === this.props.currentFontFamily
        })

        const currentFont = fontByName ? fontByName : find(allFontsMap, (fontOption: FontOptionType) => {
            return fontOption.name === 'Roboto'
        })

        const preferredFonts = fontsInProject.map((fontFromProject: string) => {
            const selected = find(imagickFonts.data.fontsMap, (item, key) => {
                return fontFromProject === item.text_fontfamily
            })

            const fam = selected && typeof imagickFonts.data.allAvailableFamilies[selected.family] !== 'undefined' ? imagickFonts.data.allAvailableFamilies[selected.family] :  null
            if (fam) {
                return {
                    family: fam.family,
                    value: fam.family,
                    image: fam.image,
                    text_fontfamily: fam.text_fontfamily,
                    styles: fam.styles,
                }
            }
        }).filter((ff: FontFamilyOptionType) => {
            return ff
        })

        const uniquePreferredFonts = uniqBy(preferredFonts, (ff: FontFamilyOptionType) => ff?.text_fontfamily)

        const availableFontFamilies = Object.keys(imagickFonts.data.allAvailableFamilies).map((key: string) => {
            const fam = imagickFonts.data.allAvailableFamilies[key] ?? null
            return {
                family: fam.family,
                value: fam.family,
                image: fam.image,
                text_fontfamily: fam.text_fontfamily,
                styles: fam.styles,
            }
        })

        const fontFamilyOptions = uniquePreferredFonts.length > 0
            ? [
                { label: trans('recently_used'), options: uniquePreferredFonts.reverse() },
                { label: trans('all'), options: availableFontFamilies },
            ]
            : availableFontFamilies

        const currentFontFamily = imagickFonts.data.allAvailableFamilies[currentFont.family]

        const currentFontAvailableStyles = typeof currentFontFamily !== 'undefined' ?
            Object.keys(imagickFonts.data.allAvailableFamilies[currentFont.family].styles).map((key: string) => ({
                label: imagickFonts.data.allAvailableFamilies[currentFont.family].styles[key]['name'],
                value: imagickFonts.data.allAvailableFamilies[currentFont.family].styles[key]['text_fontfamily'],
                image: imagickFonts.data.allAvailableFamilies[currentFont.family].styles[key]['image'],
            })) : []

        return (
            <>
                <GridCell>
                    {imagickFonts.data.allAvailableFamilies &&
                        <StyledSelect
                            search={true}
                            filterOption={this.customFilter}
                            placeholder={trans('imagick_fonts')}
                            multiple={false}
                            closeOnBlur={true}
                            closeOnChange={true}
                            highlightTextGetter={this.highlightTextGetter}
                            id={'font-family'}
                            value={currentFontFamily}
                            options={fontFamilyOptions}
                            isOptionSelected={option => currentFontFamily.family === option.family}
                            getOptionLabel={option => <div className={'label-wrapper'}>
                                {option.family}
                                <Example font={option.text_fontfamily} className="example">
                                    {this.props.sampleText ? this.props.sampleText : option.family}
                                </Example>
                            </div>}
                            onChange={(e) => {
                                if (e) {
                                    this.props.setFontFamily(e.text_fontfamily)
                                    if (!fontsInProject.includes(e.text_fontfamily)) {
                                        const updatedFonts = [...fontsInProject, e.text_fontfamily]
                                        this.props.setFontsInProjectToStore(updatedFonts)
                                    }
                                }
                            }}
                            style={{
                                ' div[class$="-group"]': {
                                    backgroundColor: '#000',
                                    color: '#ccc',
                                    textAlign: 'center',
                                    fontSize: '8px',
                                    fontStyle: 'italic',
                                    fontWeight: 'bold',
                                    border: 0,
                                    margin: 0,
                                },
                            }}
                        />
                    }
                </GridCell>

                <GridCell title={trans('imagick_fonts_style')}>
                    {currentFontAvailableStyles &&
                        <StyledSelect
                            id={'font-style'}
                            key={`${this.props.currentFontFamily}${currentFont.family}${currentFont.style}`}
                            search={true}
                            filterOption={this.customFilter}
                            closeOnBlur={true}
                            closeOnChange={true}
                            multiple={false}
                            highlightTextGetter={this.highlightTextGetter}
                            value={currentFont}
                            options={currentFontAvailableStyles}
                            isOptionSelected={option => currentFont.value === option.value}
                            getOptionLabel={option => <div className={'label-wrapper'}>
                                {option.label ?? option.style}
                                <Example font={option.value} className="example">
                                    {this.props.sampleText ? this.props.sampleText : (option.label ?? option.style)}
                                </Example>
                            </div>}
                            getOptionValue={option => option.value}
                            onChange={(e) => {
                                if (e) {
                                    this.props.setFontFamily(e.value)
                                    if (!fontsInProject.includes(e.value)) {
                                        const updatedFonts = [...fontsInProject, e.value]
                                        this.props.setFontsInProjectToStore(updatedFonts)
                                    }
                                }
                            }}
                        />
                    }
                </GridCell>
            </>
        )
    }
}

const StyledSelect = css(Select)({
    " span .label-wrapper div": {
        display: 'block',
    },
    "[class*=singleValue]": {
        ".label-wrapper": {
            fontSize: "14px",
        },
        ".example": {
            display: "none",
        },
    },
    ' .label-wrapper': {
        fontSize: "10px",
        overflow: 'hidden',
        ' img': {
            paddingTop: '8px',
        },
        // " div": {
        //     display: "none",
        // }
    },
    ' .option-image': {
        maxWidth: '100%',
    },
    ' .float-right': {
        float: 'right',
        color: Theme.blue,
    },
    ' input.react-select-item-search': {
        left: '100px',
        width: 'calc(100% - 20px)',
    },
    ' .react-select-item-options': {
        backgroundColor: '#fff',
    },
    ' div[class$="-menu"]': {
        zIndex: 99,
    },
})

const Example = css("div")({
    fontSize: "30px",
    borderBottom: "1px solid #eee",
    paddingBottom: "5px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    lineHeight: "36px",
    height: "36px",
}, props => ({
    fontFamily: "'" + props.font + "','Unicode-BMP-Fallback-SIL'"
}))

function mapStateToProps(state) {
    return {
        imagickFonts: state.imagickFonts,
        fontsInProject: state.fontsInProject,
    }
}

export default connect(mapStateToProps, {
    setFontsInProjectToStore,
})(ImagickFontSelect)
